module.exports = __webpack_public_path__ + "static/blog61-15abc829f473c74d4dcb0db617905c53.png";